// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2xt-n","title":"Info_title__3dQBt","selects":"Info_selects__1_PTE","requiredAsterisk":"Info_requiredAsterisk__euJCi"};